import { MutationCache, QueryClient } from '@tanstack/react-query';
import { getAuthentication } from 'shared/services/backend-api/helpers';
import { getRollbar } from 'shared/services/error-tracking';

import { getMutationErrorContext } from './get-mutation-error-context';

const mutationCache = new MutationCache({
  onError: async (error, variables, _context, mutation) => {
    const auth = await getAuthentication();
    const uid = auth.currentUser?.uid;
    const errorContext = getMutationErrorContext(
      error,
      variables,
      mutation,
      uid,
    );

    if (!errorContext) {
      return;
    }

    getRollbar().error('Mutation Failed', error as Error, errorContext);
  },
});

export const queryClient = new QueryClient({
  mutationCache,
  defaultOptions: {
    mutations: {
      networkMode: 'offlineFirst',
    },
    queries: {
      staleTime: Infinity,
      gcTime: 60 * 60 * 1000,
      suspense: true,
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  },
});
